if (!customElements.get('sticky-buy-bar')) {
  customElements.define('sticky-buy-bar', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      const section = this.closest('[data-section-type="product"]');
      if (!section) return;

      const scrollTarget = document.querySelector('#product-variant-title');
      const submitGroup = section.querySelector('.product-form__controls-group--submit');
      const cta = this.querySelector('[data-sv-mobile-sticky-bar-cta]');
      const mobileMq = window.matchMedia('(max-width:749px)');
      const pageContainer = document.getElementById('PageContainer');

      const sync = (e) => {
        const mainPrice = section.querySelector('.product__price [data-price]');
        const stickyPrice = this.querySelector('[data-price]');
        if (mainPrice && stickyPrice) {
          stickyPrice.innerHTML = theme.Currency.formatMoney(e.detail.variant.price, theme.moneyFormat);
          stickyPrice.className = mainPrice.className;
        }

        const addToCartText = section.querySelector('[data-add-to-cart-text]');
        if (addToCartText && cta) cta.textContent = addToCartText.textContent.trim();
      };

      const setVisible = visible => {
        this.classList.toggle('hide', !visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (pageContainer && mobileMq.matches) {
          pageContainer.style.paddingBottom = visible ? this.offsetHeight + 'px' : '';
        }
      };

      const observer = new IntersectionObserver(entries => {
        setVisible(!entries[0].isIntersecting);
      }, { threshold: 0 });

      if (mobileMq.matches && submitGroup) observer.observe(submitGroup);

      if (cta && scrollTarget) {
        cta.addEventListener('click', e => {
          e.preventDefault();
          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
          const top = window.scrollY + scrollTarget.getBoundingClientRect().top - headerHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      }

      document.addEventListener('variantChange', sync);
      sync();
    }
  });
}